export default function getCellStyle(column, style = {}) {
	if (column.onClick) {
		style.cursor = "pointer";
	}

	if (column.noWrap) {
		style.whiteSpace = "nowrap";
	}

	if (column.sticky) {
		style = {
			...style,
			position: "sticky",
			right: 0,
			left: 0,
			zIndex: 1,
			minWidth: 40,
			backgroundColor: "var(--color-bg-card)",
			borderRight: column.first ? "1px solid var(--color-border)" : "none",
			borderLeft: !column.first ? "1px solid var(--color-border)" : "none",
		};
	}

	return style;
}
